<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Old Montenegro region</h1>
    <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>

    <div>
      <div class='' id=''>
        <p class='pasus'>
          Probably the most celebrated region of Montenegro tells a story about
          Montenegro's fight for freedom, its independence, and medieval rulers'
          readiness for sacrifice - they had left cultivated and rich areas
          around Skadar Lake not to become hostages of powerful Ottoman Empire
          and having found their shelter in the karst field in the foot of
          Lovcen Mountain they founded a new capital of Montenegro, a spiritual
          center which would inspire Montenegrins for centuries onward becoming
          their greatest ally in preserving the torch of freedom on conquered
          Balkan peninsula.
        </p>
        <p class='pasus'>
          Cetinje thus becomes maybe the smallest capital of some libertarian
          people, Lovcen Mountain nearby a Montenegrin Olimp and the small
          population a new Sparta which would successfully resist pressures and
          war attacks of powerful empire over centuries.
        </p>
        <p class='pasus'>
          The region of so called Old Montenegro and Cetinje, though not so old
          as some of antic towns on the coast or other parts of Montenegro,
          still tells the most famous story of the smallest country in the
          Balkans.
        </p>
        <p class='pasus'>
          Cetinje, as an old historical capital can also be considered a museum
          town with its old town center and famous Cetinje Monastery, a home to
          prominent Christian relics. It is located at 600 meters above sea
          level in a tiny karst field and very close to Podgorica, Budva and
          Kotor each of which being in the focus of tourism and economic
          activities.
        </p>
        <p class='pasus'>
          Lovcen Mountain belongs to the national park of the same name which
          provides stunning views on the bride of Adriatic – Boka Bay, whose
          second highest peak is where the highest mausoleum in Europe is
          situated and where the most famous among all eminent Montenegrins,
          Petar II Petrovic Njegos, found his eternal rest.
        </p>
        <p class='pasus'>
          Old Montenegro region also covers a part of national park Skadar Lake;
          a charming little town on the lake’s coast – Rijeka Crnojevica, which
          for long used to be the most important Montenegrin harbor and its only
          water connection with civilization but also the largest market
          (Pazar); the best-known Montenegro’s village Njegusi, the cradle of
          the most prominent Petrovici dynasty and far-known for its smoked ham,
          cheese and mead.
        </p>
        <p class='pasus'>
          This region is known for its wine, honey and lake fish, and it’s where
          handsome men and tall ladies are very proud of their famous history
          and tradition.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/placestogo/02/01.jpg'),
          thumbnail: require('@/assets/placestogo/02/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/02.jpg'),
          thumbnail: require('@/assets/placestogo/02/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/03.jpg'),
          thumbnail: require('@/assets/placestogo/02/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/04.jpg'),
          thumbnail: require('@/assets/placestogo/02/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/05.jpg'),
          thumbnail: require('@/assets/placestogo/02/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/06.jpg'),
          thumbnail: require('@/assets/placestogo/02/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/07.jpg'),
          thumbnail: require('@/assets/placestogo/02/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/02/08.jpg'),
          thumbnail: require('@/assets/placestogo/02/08.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/PTG2_OldMontenegro.vue